import { END_POINTS } from "../helpers";
import { CommonBody, OtpResponse, Users } from "../types/General";
import { User } from "../types/User";
import emptySplitApi from "../utils/rtk";

type CommonResponse = {
  statusCode: number;
  message?: string;
  data?: any;
};

export const authApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getCategory: builder.query<CommonResponse, {}>({
      query: () => ({
        url: END_POINTS.category,
        method: "GET",
      }),
    }),

    getSubCategory: builder.query<
      CommonResponse,
      { parentId: string | undefined }
    >({
      query: ({ parentId }) => ({
        url: `${END_POINTS.category}?categoryIds=${parentId}`,
        method: "GET",
      }),
    }),
    getCms: builder.query<CommonResponse, {}>({
      query: () => ({
        url: END_POINTS.getCms,
        method: "GET",
      }),
    }),
    getFaq: builder.query<CommonResponse, {}>({
      query: () => ({
        url: END_POINTS.getFaq,
        method: "GET",
      }),
    }),
  }),
});

export const { useLazyGetCategoryQuery, useLazyGetSubCategoryQuery ,useLazyGetCmsQuery,useLazyGetFaqQuery    } = authApi;
